import { Box, Modal, Paper, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 700,
  bgcolor: 'background.paper',
  border: '1px solid #ccc',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const LearnMoreModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Paper sx={style}>
        <Box
          sx={{ mb: 3, display: 'flex', justifyContent: 'space-around', gap: 2, flexWrap: 'wrap' }}
        >
          <Typography variant='h4' sx={{ color: 'secondary.main', textTransform: 'uppercase' }}>
            Integrity.
          </Typography>
          <Typography variant='h4' sx={{ color: 'secondary.main', textTransform: 'uppercase' }}>
            Family.
          </Typography>
          <Typography variant='h4' sx={{ color: 'secondary.main', textTransform: 'uppercase' }}>
            Tradition.
          </Typography>
          <Typography variant='h4' sx={{ color: 'secondary.main', textTransform: 'uppercase' }}>
            Drive.
          </Typography>
        </Box>
        <Typography variant='body1' sx={{ color: 'gray', mb: 2 }}>
          These are the principles that for over 183 years have driven our company through five
          generations of Dickson family leadership with one sole focus - distribution. In 1841, two
          Welsh immigrants opened an apothecary shop in the rural township of Shreveport. In its
          earliest days, the business supplied everything the pioneer was likely to need to survive
          in a frontier town: quinine to fight malaria, mustard to make plasters, and tools to fight
          varmints, scoundrels, and scallywags. Today the family tradition continues at Sports
          South. Every day, it meets the challenges set forth by its founding fathers by providing
          the right product to the right place at the right time.
        </Typography>
        <Typography variant='body1' sx={{ color: 'gray', textIndent: '2em' }}>
          As the country's oldest and largest distributor of outdoor sporting merchandise, Sports
          South maintains its leadership position through the relentless pursuit of new ideas and
          new thinking to drive long-term success and growth. With the nation's largest
          concentration of outdoor sports inventory from all the leading manufacturers under one
          roof, Sports South can deliver unmatched distribution services to its customers. If you
          haven't already, please give us the opportunity to prove it! Sports South is a family
          company and these values permeate its culture to all its employees and its customers. Hard
          work, education, and hands-on involvement, along with the assured well-being and
          livelihood of hundreds of employees, reinforce the company's dedication to its origin.
        </Typography>
      </Paper>
    </Modal>
  );
};

export default LearnMoreModal;
